module.exports = __webpack_public_path__ + "static/media/ui-icons-staff-rota-on.c57d30aa.svg";